import React from 'react';
import { matchPath } from 'react-router-dom';

import { rulesEngineSelectors } from '@dndbeyond/character-rules-engine/es';

import { RouteKey, BuilderMethod, SectionKey, NavigationType } from '../constants/navigation';
import AbilityScoresHelp from '../containers/pages/AbilityScoresHelp';
import AbilityScoresManage from '../containers/pages/AbilityScoresManage';
import ClassChoose from '../containers/pages/ClassChoose';
import ClassHelp from '../containers/pages/ClassHelp';
import ClassesManage from '../containers/pages/ClassesManage';
import DescriptionHelp from '../containers/pages/DescriptionHelp';
import DescriptionManage from '../containers/pages/DescriptionManage';
import EquipmentHelp from '../containers/pages/EquipmentHelp';
import EquipmentManage from '../containers/pages/EquipmentManage';
import HomeBasicInfo from '../containers/pages/HomeBasicInfo';
import HomeHelp from '../containers/pages/HomeHelp';
import QuickBuild from '../containers/pages/QuickBuild';
import RaceChoose from '../containers/pages/RaceChoose';
import RaceHelp from '../containers/pages/RaceHelp';
import RaceManage from '../containers/pages/RaceManage';
import RandomizeBuild from '../containers/pages/RandomizeBuild';
import WhatsNext from '../containers/pages/WhatsNext';
import { NavigationUtils } from '../utils';

// export interface RouteDefinition {
//     key: string,
//     type: string,
//     path: string,
//     Component: any,
//     checkCanAccess: (routeDef:any, state:any) => boolean,
// }

import config from '~/config';

const BASE_PATHNAME = config.basePathname;


export const ROUTE_DEFINITIONS = {
    [RouteKey.QUICK_BUILD]: {
        key: RouteKey.QUICK_BUILD,
        type: NavigationType.Page,
        path: `${BASE_PATHNAME}/builder/quick-build`,
        Component: QuickBuild,
        checkCanAccess: (routeDef, state) => {
            return NavigationUtils.checkStdBuilderPageRequirements(routeDef, state);
        },
    },
    [RouteKey.RANDOMIZE_BUILD]: {
        key: RouteKey.RANDOMIZE_BUILD,
        type: NavigationType.Page,
        path: `${BASE_PATHNAME}/builder/randomize`,
        Component: RandomizeBuild,
        checkCanAccess: (routeDef, state) => NavigationUtils.checkStdBuilderPageRequirements(routeDef, state),
    },
    [RouteKey.HOME_BASIC_INFO]: {
        key: RouteKey.HOME_BASIC_INFO,
        type: NavigationType.Page,
        path: `${BASE_PATHNAME}/:characterId/builder/home/basic`,
        Component: HomeBasicInfo,
        checkCanAccess: (routeDef, state) => NavigationUtils.checkStdBuilderPageRequirements(routeDef, state),
    },
    [RouteKey.RACE_CHOOSE]: {
        key: RouteKey.RACE_CHOOSE,
        type: NavigationType.Page,
        path: `${BASE_PATHNAME}/:characterId/builder/race/choose`,
        Component: RaceChoose,
        checkCanAccess: (routeDef, state, dispatch) => {
            if (!NavigationUtils.checkStdBuilderPageRequirements(routeDef, state)) {
                return false;
            }

            if (rulesEngineSelectors.getRace(state) !== null) {
                return false;
            }

            return true;
        },
    },
    [RouteKey.RACE_MANAGE]: {
        key: RouteKey.RACE_MANAGE,
        type: NavigationType.Page,
        path: `${BASE_PATHNAME}/:characterId/builder/race/manage`,
        Component: RaceManage,
        checkCanAccess: (routeDef, state, dispatch) => {
            if (rulesEngineSelectors.getRace(state) === null) {
                return false;
            }

            return true;
        },
    },
    [RouteKey.CLASS_CHOOSE]: {
        key: RouteKey.CLASS_CHOOSE,
        type: NavigationType.Page,
        path: `${BASE_PATHNAME}/:characterId/builder/class/choose`,
        Component: ClassChoose,
        checkCanAccess: (routeDef, state, dispatch) => {
            if (!NavigationUtils.checkStdBuilderPageRequirements(routeDef, state)) {
                return false;
            }

            if (rulesEngineSelectors.getClasses(state).length > 0) {
                return false;
            }

            return true;
        },
    },
    [RouteKey.CLASS_MANAGE]: {
        key: RouteKey.CLASS_MANAGE,
        type: NavigationType.Page,
        path: `${BASE_PATHNAME}/:characterId/builder/class/manage`,
        Component: ClassesManage,
        checkCanAccess: (routeDef, state, dispatch) => {
            if (!NavigationUtils.checkStdBuilderPageRequirements(routeDef, state)) {
                return false;
            }

            if (rulesEngineSelectors.getClasses(state).length === 0) {
                return false;
            }

            return true;
        },
    },
    [RouteKey.ABILITY_SCORES_MANAGE]: {
        key: RouteKey.ABILITY_SCORES_MANAGE,
        type: NavigationType.Page,
        path: `${BASE_PATHNAME}/:characterId/builder/ability-scores/manage`,
        Component: AbilityScoresManage,
        checkCanAccess: (routeDef, state) => NavigationUtils.checkStdBuilderPageRequirements(routeDef, state),
    },
    [RouteKey.DESCRIPTION_MANAGE]: {
        key: RouteKey.DESCRIPTION_MANAGE,
        type: NavigationType.Page,
        path: `${BASE_PATHNAME}/:characterId/builder/description/manage`,
        Component: DescriptionManage,
        checkCanAccess: (routeDef, state) => NavigationUtils.checkStdBuilderPageRequirements(routeDef, state),
    },
    [RouteKey.EQUIPMENT_MANAGE]: {
        key: RouteKey.EQUIPMENT_MANAGE,
        type: NavigationType.Page,
        path: `${BASE_PATHNAME}/:characterId/builder/equipment/manage`,
        Component: EquipmentManage,
        checkCanAccess: (routeDef, state) => NavigationUtils.checkStdBuilderPageRequirements(routeDef, state),
    },

    [RouteKey.WHATS_NEXT]: {
        key: RouteKey.WHATS_NEXT,
        type: NavigationType.Page,
        path: `${BASE_PATHNAME}/:characterId/builder/whats-next`,
        Component: WhatsNext,
        checkCanAccess: (routeDef, state) => NavigationUtils.checkStdBuilderPageRequirements(routeDef, state),
    },

    [RouteKey.HOME_HELP]: {
        key: RouteKey.HOME_HELP,
        type: NavigationType.HelpPage,
        path: `${BASE_PATHNAME}/:characterId/builder/home/help`,
        Component: HomeHelp,
        checkCanAccess: (routeDef, state) => NavigationUtils.checkStdBuilderPageRequirements(routeDef, state),
    },
    [RouteKey.RACE_HELP]: {
        key: RouteKey.RACE_HELP,
        type: NavigationType.HelpPage,
        path: `${BASE_PATHNAME}/:characterId/builder/race/help`,
        Component: RaceHelp,
        checkCanAccess: (routeDef, state) => NavigationUtils.checkStdBuilderPageRequirements(routeDef, state),
    },
    [RouteKey.CLASS_HELP]: {
        key: RouteKey.CLASS_HELP,
        type: NavigationType.HelpPage,
        path: `${BASE_PATHNAME}/:characterId/builder/class/help`,
        Component: ClassHelp,
        checkCanAccess: (routeDef, state) => NavigationUtils.checkStdBuilderPageRequirements(routeDef, state),
    },
    [RouteKey.ABILITY_SCORES_HELP]: {
        key: RouteKey.ABILITY_SCORES_HELP,
        type: NavigationType.HelpPage,
        path: `${BASE_PATHNAME}/:characterId/builder/ability-scores/help`,
        Component: AbilityScoresHelp,
        checkCanAccess: (routeDef, state) => NavigationUtils.checkStdBuilderPageRequirements(routeDef, state),
    },
    [RouteKey.DESCRIPTION_HELP]: {
        key: RouteKey.DESCRIPTION_HELP,
        type: NavigationType.HelpPage,
        path: `${BASE_PATHNAME}/:characterId/builder/description/help`,
        Component: DescriptionHelp,
        checkCanAccess: (routeDef, state) => NavigationUtils.checkStdBuilderPageRequirements(routeDef, state),
    },
    [RouteKey.EQUIPMENT_HELP]: {
        key: RouteKey.EQUIPMENT_HELP,
        type: NavigationType.HelpPage,
        path: `${BASE_PATHNAME}/:characterId/builder/equipment/help`,
        Component: EquipmentHelp,
        checkCanAccess: (routeDef, state) => NavigationUtils.checkStdBuilderPageRequirements(routeDef, state),
    },
};
export interface RouteDef {
    key: string; // get the thing as an enum
    type: NavigationType;
    path: string;
    Component: React.ComponentType<any>;
    checkCanAccess?: (routeDef: RouteDef, state: any) => boolean;
}

export const getAllRouterRoutes = () => {
    return Object.values(ROUTE_DEFINITIONS).map((routeDef: RouteDef) => ({
        element: <routeDef.Component />,
        path: routeDef.path,
        routeDef,
    }));
};

export const getRouteDef = (routeKey) => ROUTE_DEFINITIONS[routeKey];
export const getRouteDefPath = (routeKey) => getRouteDef(routeKey).path;
export const getRouteDefType = (routeKey) => getRouteDef(routeKey).type;

export const NAVIGATION_DEFINITIONS = {
    [BuilderMethod.QUICK]: [
        {
            type: NavigationType.Section,
            key: SectionKey.QUICK_BUILD,
            label: 'Quick Build',
            routes: [getRouteDef(RouteKey.QUICK_BUILD)],
        },
    ],
    [BuilderMethod.RANDOMIZE]: [
        {
            type: NavigationType.Section,
            key: SectionKey.RANDOMIZE,
            label: 'Randomize Build',
            routes: [getRouteDef(RouteKey.RANDOMIZE_BUILD)],
        },
    ],
    [BuilderMethod.STEP_BY_STEP]: [
        {
            type: NavigationType.Section,
            key: SectionKey.HOME,
            label: 'Home',
            routes: [getRouteDef(RouteKey.HOME_HELP), getRouteDef(RouteKey.HOME_BASIC_INFO)],
        },
        {
            type: NavigationType.Section,
            key: SectionKey.RACE,
            label: '1. Race',
            routes: [
                getRouteDef(RouteKey.RACE_HELP),
                getRouteDef(RouteKey.RACE_CHOOSE),
                getRouteDef(RouteKey.RACE_MANAGE),
            ],
        },
        {
            type: NavigationType.Section,
            key: SectionKey.CLASS,
            label: '2. Class',
            routes: [
                getRouteDef(RouteKey.CLASS_HELP),
                getRouteDef(RouteKey.CLASS_CHOOSE),
                getRouteDef(RouteKey.CLASS_MANAGE),
            ],
        },
        {
            type: NavigationType.Section,
            key: SectionKey.ABILITY_SCORES,
            label: '3. Abilities',
            routes: [getRouteDef(RouteKey.ABILITY_SCORES_HELP), getRouteDef(RouteKey.ABILITY_SCORES_MANAGE)],
        },
        {
            type: NavigationType.Section,
            key: SectionKey.DESCRIPTION,
            label: '4. Description',
            routes: [getRouteDef(RouteKey.DESCRIPTION_HELP), getRouteDef(RouteKey.DESCRIPTION_MANAGE)],
        },
        {
            type: NavigationType.Section,
            key: SectionKey.EQUIPMENT,
            label: '5. Equipment',
            routes: [getRouteDef(RouteKey.EQUIPMENT_HELP), getRouteDef(RouteKey.EQUIPMENT_MANAGE)],
        },
        {
            type: NavigationType.Section,
            key: SectionKey.WHATS_NEXT,
            label: "What's Next",
            routes: [getRouteDef(RouteKey.WHATS_NEXT)],
        },
    ],
};

export function checkIsRouteInSection(testRouteDef, sectionRoutes) {
    if (testRouteDef && sectionRoutes) {
        return !!sectionRoutes.filter((routeDef) => routeDef.key === testRouteDef.key).length;
    }

    return false;
}

export function getNavigationSections(builderMethod, currentRouteDef) {
    const navConfig = getNavBuilderConfig(builderMethod);

    return navConfig.map((section) => ({
        ...section,
        active: checkIsRouteInSection(currentRouteDef, section.routes),
    }));
}

export function getNavBuilderConfig(builderMethod) {
    if (builderMethod) {
        return NAVIGATION_DEFINITIONS[builderMethod];
    } else {
        return [];
    }
}

export function getCurrentRouteDef(currentPath) {
    const routes = getAllRouterRoutes();

    let matchedRouteDef: RouteDef | null = null;
    routes.forEach((route) => {
        const match = matchPath(route.path, currentPath);

        if (match) {
            matchedRouteDef = route.routeDef;
        }
    });

    return matchedRouteDef;
}
